export default "__VITE_ASSET__BKOKx5x1__"